import { Component, Input } from '@angular/core';

/** Temporary stand-in for pages not yet built out (see build plan phases).
 * Keeps routing/navigation functional while features land incrementally. */
@Component({
  selector: 'app-placeholder',
  standalone: true,
  template: `
    <div class="mx-auto flex min-h-[50vh] max-w-2xl flex-col items-center justify-center px-4 py-24 text-center">
      <h1 class="font-display text-3xl font-semibold text-ink">{{ title }}</h1>
      <p class="mt-3 text-sm text-ink/70">{{ description }}</p>
    </div>
  `,
})
export class PlaceholderComponent {
  @Input() title = 'Coming soon';
  @Input() description = "This part of Galopa hasn't been built yet.";
}
